import React from 'react';
import PropTypes from 'prop-types';
import './Loader.css';


const Loader = ({ message }) => {
    return (
        <>

            {!message && (
                <div className="loader-container">
                    <div className="loader bg-black  vh-100 d-flex justify-content-center align-items-center">
                        <video
                            src={process.env.PUBLIC_URL + '/images/plot_loader_vid.mp4'}
                            autoPlay
                            loop
                            muted
                            className="loader-video"
                        ></video>
                    </div>
                </div>
            )
            }
            {/* Conditionally render the message if passed via props */}
            {
                message && (
                    <>
                        <div className="loader-container  bg-black-light">
                            <div className="loader vh-100 d-flex justify-content-center align-items-center">
                                <div className="loader-text text-white ft-10 mt-3">{message}</div>
                            </div>
                        </div >
                    </>
                )
            }

        </>
    );
}
Loader.propTypes = {
    message: PropTypes.string
};
export default Loader;